import styled from 'styled-components';

export const Content = styled.div`
  width: 100%;
  margin-bottom: 13px;
`;

export const SliderWrapper = styled.div`
  width: 100%;
`;

export const Title = styled.h1`
  font-size: 20px;
  font-weight: bold;
  line-height: 1.3;
  text-align: center;
  color: #1b1b1b;
  margin-top: 0;
  margin-bottom: 0;
`;
